/*
 * UserEditPage Messages
 *
 * This contains all the text for the UserEditPage container.
 */
import { defineMessages } from "react-intl";

export const scope = "app.containers.UserEditPage";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "Account",
  },
  location: {
    id: `${scope}.location`,
    defaultMessage: "Switch location",
  },
  dentist: {
    id: `${scope}.dentist`,
    defaultMessage: "Overview dentists within practice.",
  },
  dentists_header: {
    id: `${scope}.dentists_header`,
    defaultMessage: "Dentists",
  },
  product_settings: {
    id: `${scope}.product_settings`,
    defaultMessage: "Product settings",
  },
  product_button: {
    id: `${scope}.product_button`,
    defaultMessage: "Change/view default settings",
  },
  selectPractice: {
    id: `${scope}.selectPractice`,
    defaultMessage: "Select Practice",
  },
  messages: {
    id: `${scope}.messages`,
    defaultMessage: "Messages",
  },

  messagesHeader: {
    id: `${scope}.messagesHeader`,
    defaultMessage: "Messages",
  },
});
